export function newModifiedArray(array, indexes, newValue) {
  const newArray = array.slice(0);
  if (Array.isArray[indexes]) {
    indexes.foraEach(index => {
      newArray[index] = newValue;
    })
  } else {
    newArray[indexes] = newValue;
  }
  return newArray;
};